import { __ } from "@wordpress/i18n";
import React, { useState, useEffect } from "react";
import apiFetch from "@wordpress/api-fetch";

const DebugLogs = () => {
	const [logs, setLogs] = useState([]);
	const [isLoadingLogs, setIsLoadingLogs] = useState(false);

	useEffect(() => {
		turnstile_logs();
	}, []);

	const turnstile_logs = async () => {
		try {
			setIsLoadingLogs(true);
			const response = await apiFetch({
				path: `/ultimate-security/v1/turnstile-logs`,
				method: "GET",
			});

			// The response is the array of logs
			setLogs(response);
			setIsLoadingLogs(false);
		} catch (error) {
			// console.error("Error fetching turnstile logs:", error);
			setIsLoadingLogs(false);
		}
	};

	// Function to format date strings
	const formatDate = (dateString) => {
		try {
			return new Date(dateString).toLocaleString();
		} catch (e) {
			return dateString;
		}
	};

	// Format logs for copy/paste
	const formatLogsForCopy = () => {
		return logs
			.map((log, index) => {
				const info = log.info || {};
				return `Log #${index + 1}\nDate: ${log.date || "N/A"}\nIP: ${
					info.ip || "N/A"
				}\nURL: ${info.url || "N/A"}\nForm Type: ${
					info.form_type || "N/A"
				}\nSuccess: ${log.success ? "Yes" : "No"}\nResponse: ${
					log.response || "N/A"
				}\nUser Agent: ${info.user_agent || "N/A"}\n`;
			})
			.join("\n---------------------------\n");
	};

	// Handle copy button click
	const handleCopyLogs = () => {
		const logsText = formatLogsForCopy();
		navigator.clipboard.writeText(logsText);
		alert(
			__(
				"Logs copied to clipboard!",
				"ultimate-security",
			),
		);
	};

	// Handle print button click
	const handlePrintLogs = () => {
		const printWindow = window.open("", "_blank");
		const logsHtml = `
                    <html>
                        <head>
                            <title>Turnstile Logs</title>
                            <style>
                                body { font-family: sans-serif; margin: 20px; }
                                h1 { color: #333; }
                                .log-entry { border: 1px solid #ddd; margin-bottom: 20px; padding: 15px; border-radius: 5px; }
                                .success { color: green; }
                                .failure { color: red; }
                                .log-header { font-weight: bold; margin-bottom: 10px; display: flex; justify-content: space-between; }
                                .log-details { margin-left: 15px; }
                                .log-row { margin-bottom: 5px; }
                            </style>
                        </head>
                        <body>
                            <h1>Cloudflare Turnstile Logs</h1>
                            ${logs
								.map((log, index) => {
									const info = log.info || {};
									return `
                                    <div class="log-entry">
                                        <div class="log-header">
                                            <span>Log #${index + 1}</span>
                                            <span class="${
												log.success
													? "success"
													: "failure"
											}">${
												log.success
													? "Success"
													: "Failure"
											}</span>
                                        </div>
                                        <div class="log-details">
                                            <div class="log-row"><strong>Date:</strong> ${
												log.date || "N/A"
											}</div>
                                            <div class="log-row"><strong>IP:</strong> ${
												info.ip || "N/A"
											}</div>
                                            <div class="log-row"><strong>URL:</strong> ${
												info.url || "N/A"
											}</div>
                                            <div class="log-row"><strong>Form Type:</strong> ${
												info.form_type || "N/A"
											}</div>
                                            <div class="log-row"><strong>Response:</strong> ${
												log.response || "N/A"
											}</div>
                                            <div class="log-row"><strong>User Agent:</strong> ${
												info.user_agent || "N/A"
											}</div>
                                        </div>
                                    </div>
                                `;
								})
								.join("")}
                        </body>
                    </html>
                `;
		printWindow.document.write(logsHtml);
		printWindow.document.close();
		printWindow.print();
	};
	return (
		<>
			<div className="setting-input border-top border-bottom mb-lg">
				<div className="title-group py-3">
					<h5 className="pl-heading-1 fw-600 text-text">
						{__(
							"Turnstile Debug Log",
							"ultimate-security",
						)}
					</h5>
					<p className="pl-body text-text">
						{__(
							"View logs of Cloudflare Turnstile verification attempts on your site.",
							"ultimate-security",
						)}
					</p>
				</div>
			</div>
			<div className="setting-unit pb-lg mb-lg pt-lg mt-lg">
				<div className="panel-wrapper">
					<div className="panel">
						<div className="panel-header d-flex justify-content-between align-items-center">
							<span>
								{__(
									"Recent Activity",
									"ultimate-security",
								)}
							</span>
							<button
								onClick={turnstile_logs}
								className="refresh-btn"
								style={{
									background: "#f0f0f0",
									border: "1px solid #ddd",
									borderRadius: "4px",
									padding: "5px 10px",
								}}
								disabled={isLoadingLogs}
							>
								{isLoadingLogs
									? __(
											"Loading...",
											"ultimate-security",
									  )
									: __(
											"Refresh",
											"ultimate-security",
									  )}
							</button>
						</div>
						<div className="panel-body">
							<div id="copy-content">
								{isLoadingLogs ? (
									<div className="text-center py-4">
										{__(
											"Loading logs...",
											"ultimate-security",
										)}
									</div>
								) : logs && logs.length > 0 ? (
									<div className="turnstile-logs">
										{logs.map((log, index) => {
											const info = log.info || {};
											return (
												<div
													key={index}
													className="log-item"
													style={{
														border: "1px solid #e0e0e0",
														borderRadius: "4px",
														padding: "10px",
														marginBottom: "10px",
														backgroundColor:
															log.success
																? "#f8fff8"
																: "#fff8f8",
													}}
												>
													<div
														className="log-header"
														style={{
															display: "flex",
															justifyContent:
																"space-between",
															marginBottom: "8px",
															borderBottom:
																"1px solid #e0e0e0",
															paddingBottom:
																"5px",
														}}
													>
														<strong>
															{formatDate(
																log.date,
															)}
														</strong>
														<span
															style={{
																color: log.success
																	? "green"
																	: "red",
																fontWeight:
																	"bold",
															}}
														>
															{log.success
																? __(
																		"Success",
																		"ultimate-security",
																  )
																: __(
																		"Failed",
																		"ultimate-security",
																  )}
														</span>
													</div>
													<div
														className="log-content"
														style={{
															fontSize: "13px",
														}}
													>
														<div>
															<strong>
																{__(
																	"IP:",
																	"ultimate-security",
																)}
															</strong>{" "}
															{info.ip || "N/A"}
														</div>
														<div>
															<strong>
																{__(
																	"Form:",
																	"ultimate-security",
																)}
															</strong>{" "}
															{info.form_type ||
																"N/A"}
														</div>
														<div>
															<strong>
																{__(
																	"URL:",
																	"ultimate-security",
																)}
															</strong>{" "}
															{info.url || "N/A"}
														</div>
														<div>
															<strong>
																{__(
																	"Response:",
																	"ultimate-security",
																)}
															</strong>{" "}
															{log.response ||
																"N/A"}
														</div>
													</div>
												</div>
											);
										})}
									</div>
								) : (
									<div className="text-center py-4">
										{__(
											"No logs found.",
											"ultimate-security",
										)}
									</div>
								)}
							</div>
						</div>
						<div className="panel-footer">
							{logs && logs.length > 0
								? __(
										`Showing ${logs.length} log entries`,
										"ultimate-security",
								  )
								: __(
										"No logs available",
										"ultimate-security",
								  )}
						</div>
					</div>
					<div className="d-flex align-items-center justify-content-between mt-lg">
						<div
							className="info"
							style={{
								background: "#D1C1FF",
								color: "#5007AA",
								border: "1px solid #5007AA",
								padding: "8px 12px",
								borderRadius: "4px",
							}}
						>
							ℹ️{" "}
							{__(
								"If you need help, copy and paste the above information for faster support.",
								"ultimate-security",
							)}
						</div>
						<div className="d-flex align-items-center action-buttons">
							<button
								className="copy-content"
								onClick={handleCopyLogs}
								style={{
									marginRight: "10px",
									padding: "5px 15px",
								}}
							>
								{__(
									"Copy",
									"ultimate-security",
								)}
							</button>
							<button
								className="print-content"
								onClick={handlePrintLogs}
								style={{ padding: "5px 15px" }}
							>
								{__(
									"Print",
									"ultimate-security",
								)}
							</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default DebugLogs;
